/* eslint-disable react/prop-types */
import React from 'react';
import {
  Button,
  Breadcrumbs,
  Typography,
  Paper,
  Box,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Link
} from '@material-ui/core';
import { Description, Folder } from '@material-ui/icons';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Modal from 'components/Modal';
import classes from './Modal.module.scss';
import { get } from 'lodash';
const emptyFolder = require('assets/img/productDetail_empty_folder.jpg');

const MoveToModal = ({ data, files, selected, activeTab, open, title, initialValue, handleClose, handleSubmit }) => {
  const [value, setValue] = React.useState(initialValue || '');
  const [parentFolderId, setParentFolderId] = React.useState(0);
  const [isBaseFolder, setIsBaseFolder] = React.useState(false);
  const [baseFolder, setBaseFolder] = React.useState(activeTab);
  const [currentFolder, setCurrentFolder] = React.useState([]);
  const [breadcrumbs, setBreadcrumbs] = React.useState([]);
  const tabs = Object.keys(files);
  React.useEffect(() => {
    setValue(initialValue);
    if (initialValue.id == 0) {
      setCurrentFolder(data);
    } else {
      tabs.map(tab => {
        if (tab.toLowerCase() == activeTab.toLowerCase()) {
          let currentTabFiles = get(files, `${tab}.fileArr`);
          setParentFolderId(initialValue.id);
          setCurrentFolder(currentTabFiles);
        }
      });
    }
  }, [initialValue]);

  // for breadcrumbs use
  React.useEffect(() => {
    findCurrentFolderPath([], parentFolderId);
  }, [parentFolderId]);

  const reset = () => {
    setValue('');
  };

  const handleClickBaseLevelFolder = (folderName) => {
    setBaseFolder(folderName);
    setIsBaseFolder(false);
    tabs.map(tab => {
      if (tab.toLowerCase() == folderName.toLowerCase()) {
        let currentTabFiles = get(files, `${folderName}.fileArr`);
        setParentFolderId(0);
        setCurrentFolder(currentTabFiles);
      }
    });
  }

  const findCurrentFolderPath = (breadcrumbsArr = [], folderId) => {
    if (folderId) {
      let parent = currentFolder.find(item => item.id == folderId);
      parent && breadcrumbsArr.unshift(parent);
      if (parent && parent.parentId) {
        findCurrentFolderPath(breadcrumbsArr, parent.parentId);
      } else {
        setBreadcrumbs(breadcrumbsArr);
      }
    }
  }

  return (
    <Modal
      modalProps={{
        className: { classRoot: classes.root },
        open,
        handleClose: () => {
          setValue('');
          handleClose(reset);
        },
        title,
        size: 'small',
        footer: (
          <>
            <Button
              className={classes.button}
              color='primary'
              variant='contained'
              onClick={() => {
                handleSubmit(selected, parentFolderId, baseFolder);
                setValue('');
              }}>
              Move here
            </Button>
          </>
        ),
      }}>
      <Breadcrumbs separator={<NavigateNextIcon />} className={classes.breadcrumb}>
        <Link variant='body2' onClick={() => setIsBaseFolder(true)}>
          Document
        </Link>
        {
          !isBaseFolder && (
            [...breadcrumbs].length < 1 ?
              <Typography
                variant='body2'
                onClick={() => {
                  setParentFolderId(0);
                  setBreadcrumbs([]);
                }}>
                <span style={{ textTransform: 'capitalize' }} >{baseFolder}</span>
              </Typography> :
              <Link
                variant='body2'
                onClick={() => {
                  setParentFolderId(0);
                  setBreadcrumbs([]);
                }}>
                <span style={{ textTransform: 'capitalize' }} >{baseFolder}</span>
              </Link>
          )
        }
        {
          !isBaseFolder &&
          parentFolderId &&
          [...breadcrumbs].map((item, index) => {
            return index == [...breadcrumbs].length - 1 ?
              <Typography
                variant='body2'
                onClick={() => setParentFolderId(item.id)}>
                {item.name}
              </Typography> :
              <Link
                variant='body2'
                onClick={() => setParentFolderId(item.id)}>
                {item.name}
              </Link>
          })
        }
      </Breadcrumbs>
      <Box mt='24px'>
        {
          [...currentFolder].filter(item =>
            item.parentId == parentFolderId
          ).length < 1 && !isBaseFolder ?
            <Box textAlign={'center'}>
              <img src={emptyFolder} alt="empty folder" />
              <Box marginTop={2.5}>
                This folder is empty
              </Box>
            </Box> :
            <TableContainer className={classes.container__table} component={Paper}>
              <Table>
                <TableBody>
                  {
                    isBaseFolder ?
                      [...tabs.filter(item => item != 'default')].map(item => {
                        return <TableRow className={classes.allow}>
                          <TableCell onClick={() => handleClickBaseLevelFolder(item)}>
                            <Box display='flex' alignItems='center'>
                              <Folder />
                              <span
                                className={classes.fileFolderText}
                                style={{ textTransform: 'capitalize' }}>
                                {item}
                              </span>
                              <Box marginLeft={'auto'}>
                                <NavigateNextIcon />
                              </Box>
                            </Box>
                          </TableCell>
                        </TableRow>
                      })
                      :
                      [...currentFolder].map(item => {
                        return item.parentId == parentFolderId && (
                          <TableRow className={
                            !item.documentListId &&
                              ![...selected].find(select => select == item.id) ?
                              classes.allow :
                              classes.notAllow
                          }>
                            <TableCell onClick={() => (
                              !item.documentListId &&
                              ![...selected].find(select => select == item.id) &&
                              setParentFolderId(item.id)
                            )}>
                              <Box display='flex' alignItems='center'>
                                {
                                  item.documentListId ?
                                    <Description /> :
                                    <Folder />
                                }
                                <span className={classes.fileFolderText}>
                                  {item.name}
                                </span>
                                {
                                  !item.documentListId &&
                                  ![...selected].find(select => select == item.id) &&
                                  <Box marginLeft={'auto'}>
                                    <NavigateNextIcon />
                                  </Box>
                                }
                              </Box>
                            </TableCell>
                          </TableRow>)
                      })
                  }
                </TableBody>
              </Table>
            </TableContainer>
        }
      </Box>
    </Modal>
  );
};

export default MoveToModal;
